import * as React from 'react';
import { Divider, Paper, Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import TopicMark from "@imgs/icon-campaign.png";

const kClr_m1 = "#FA9A29";
const kClr_m3 = "#FFF3E6";

export default function SoroeruCard() {
  return (
    <Box component="section" id="point" sx={{ mt: 2, pb: 0 }}>
      <Box component="div" className="container">
        <Paper sx={{
          px: { xs: 1, sm: 3 }, py: { xs: 1, sm: 3 },
          bgcolor: kClr_m3,
          border: 3, borderColor: kClr_m1, borderRadius: 4
        }}
        >
          <Card >
            {/*
            <CardMedia
              image={bgImage}
              title="green iguana"
              sx={{ height: 140, borderRadius: 3, }}
            />
            */}
            <CardContent sx={{ px: 2, py: 2 }}>
              <Grid xs={12} sm={12} sx={{ mt: 1, ml: { xs: 1, sm: 2 }, fontSize: '18px', fontWeight: 600 }}>
                <Box component="img" src={TopicMark}
                  sx={{ width: '40px', height: '40px', mb: '-10px', mr: '5px', border: 0, borderRadius: '2px' }}
                />
                ご挨拶
              </Grid>
              <Divider sx={{ mb: 3 }} />

              <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                エネルギー業界は、これまで経験したことがないような大きな変革期を迎えています。それがDX(デジタルトランスフォーメーション)とGX(グリーントランスフォーメーション)です。これまでのエネルギー供給は、化石燃料に依存し、
                それぞれのエリアをカバーするエネルギー事業者の総括原価を基に、料金が決められてきました。しかし、脱炭素と自由化に伴い、再生可能エネルギーが主役になり、不特定多数の参加者で構成される市場が安定供給の要となります。つまり、構造転換が起こっています。
                <br />
                この新しい流れは、今まで閉鎖的だったエネルギー業界の在り方を大きく変えようとしています。
                <br /><br />
                Open Quant株式会社は、ビッグデータやIoT等の技術を活用し、データの専門会社として設立されました。
                <br />
                よりデジタル化し、よりクリーンな世界へ進化している今、エネルギー市場の未来を背負うマーケットリーダーに革新的な技術を提供し、時代の潮流に応じて自らを変革することで「お客さまに選ばれる企業」として成長し続けます。
                <br /><br />
                さらに、こうして得た知見を、社会全体に還元し、地域の皆さまの発展につなげて参ります。
              </Typography>
              <br />
              <Typography variant="body2" color="text.secondary" sx={{ px: 2, textAlign: "right" }}>
                Open Quant株式会社<br />
                代表取締役　許　紅
              </Typography>
            </CardContent>
          </Card>
        </Paper>
      </Box>
    </Box>
  );
}
